// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3KlLu","title":"Header_title__TJRLZ","left":"Header_left__2zb28","clinicName":"Header_clinicName__2ehBT"};